import { Permissions } from '@/consts/permissions';
import { useAppContext } from '@/providers/AppContextProvider/AppContextProvider';

/**
 * Returns admin permission flags for the current user.
 * @returns Object with isAdmin and isAtgAdmin flags
 *   - isAdmin: true if user has ROLE_HOUSE_ADMIN or ROLE_ATG_ADMIN
 *   - isAtgAdmin: true if user has ROLE_ATG_ADMIN
 */
export const useHasPermission = () => {
    const {
        userDecoded: { authorities: permissionsList },
    } = useAppContext();

    const isAtgAdmin = permissionsList.includes(Permissions.ROLE_ATG_ADMIN);
    const isHouseAdmin = permissionsList.includes(Permissions.ROLE_HOUSE_ADMIN);
    const isAdmin = isHouseAdmin || isAtgAdmin;

    return {
        isAdmin,
        isAtgAdmin,
    };
};
